import { useEffect } from "react";

const OG_IMAGE = "https://www.serrurierparis.paris/img/serrurier-autour-de-moi.webp";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export function SEO({ title, description, path = "/", schema, image }) {
    useEffect(() => {
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:type", "website");
        setMeta("property", "og:image", image || OG_IMAGE);
        setMeta("property", "og:image:width", "1200");
        setMeta("property", "og:image:height", "630");
        setMeta("property", "og:url", `https://www.serrurierparis.paris${path}`);
        setMeta("name", "twitter:card", "summary_large_image");
        setMeta("name", "twitter:image", image || OG_IMAGE);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `https://www.serrurierparis.paris${path}`);

        let script;
        if (schema) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.dataset.seoPage = "true";
            script.text = JSON.stringify(schema);
            document.head.appendChild(script);
        }
        return () => {
            if (script) script.remove();
        };
    }, [title, description, path, schema, image]);

    return null;
}

export default SEO;
